import { Interpolation, Theme } from '@emotion/react'
import { FunctionComponent, PropsWithChildren } from 'react'
import { useStyles } from './styles'
import { useAuthContext } from '@/modules/Auth/contexts/AuthContext'
import { Redirect } from 'react-router-dom'
import { useClariStore } from '@/modules/MedicalSpecialities/store'

interface ClariPageProps {
  style?: Interpolation<Theme>
  params?: { key: string; value: string }[]
}

const ClariPage: FunctionComponent<ClariPageProps> = ({
  style,
  params,
}: PropsWithChildren<ClariPageProps>) => {
  const styles = useStyles()
  const { user, token } = useAuthContext()
  const { clinic } = useAuthContext()
  const { clariIntent } = useClariStore()

  let url = import.meta.env.VITE_APP_CLARI_URL

  if (!clinic) {
    url += '/support'
  }

  url = `${url}?displayHeader=false&welcome=true${(params ?? [])
    .map(({ key, value }) => `&${key}=${value}`)
    .join('')}`

  if (!url.includes('intent')) {
    if (clariIntent) {
      url += `&intent=${clariIntent}`
    } else {
      url += `&intent=initialMessage`
    }
  }

  if (clinic) {
    if (!token || !user?.patientId) {
      return <Redirect to={'/'} />
    }

    url = `${url}&token=${token}`
  }

  return (
    <iframe
      title="Clari"
      css={style ?? styles.iframe}
      allow="camera; microphone; clipboard-read; clipboard-write;"
      src={url}
    ></iframe>
  )
}

export default ClariPage
